"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterMarker = exports.WorkMarker = exports.PointMarker = void 0;
var _ = require("lodash");
var Constants_1 = require("./Constants");
var utils_1 = require("../utils");
var Marker = /** @class */ (function () {
    function Marker(_a) {
        var args = __rest(_a, []);
        this.lng = args.lng;
        this.lat = args.lat;
        this.type = args.type;
        this.endTime = args.endTime;
        this.startTime = args.startTime;
        this.position = { lat: args.lat, lng: args.lng };
    }
    return Marker;
}());
var PointMarker = /** @class */ (function (_super) {
    __extends(PointMarker, _super);
    function PointMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointMarker.prototype.getLabelContent = function () {
        return "".concat(utils_1.ACTIVITY_MAPPER[this.type].projectName, " ").concat(this.startTime);
    };
    PointMarker.prototype.getOptions = function () {
        return {
            position: this.position,
            labelClass: 'marker-label',
            labelContent: this.getLabelContent(),
            icon: { path: google.maps.SymbolPath.CIRCLE },
            labelAnchor: new google.maps.Point(39, 24),
        };
    };
    return PointMarker;
}(Marker));
exports.PointMarker = PointMarker;
var WorkMarker = /** @class */ (function (_super) {
    __extends(WorkMarker, _super);
    function WorkMarker(_a) {
        var _this = this;
        var args = __rest(_a, []);
        _this = _super.call(this, __assign({}, args)) || this;
        _this.project = args.project;
        return _this;
    }
    WorkMarker.prototype.getOptions = function () {
        return {
            position: this.position,
            zIndex: 10,
            icon: utils_1.ACTIVITY_MAPPER.work.iconMap,
        };
    };
    WorkMarker.prototype.getProjectDetails = function () {
        var address = this.project.addresses && this.project.addresses[0];
        return {
            type: address && address.type,
            number: address && address.number,
            street: address && address.address && address.address.street,
            city: address && address.address && address.address.city,
        };
    };
    WorkMarker.prototype.getInfoWindowContent = function () {
        var projectDetails = this.getProjectDetails();
        return ('<div id="marker-info">'
            + '<div class="row">'
            + '<div class="label">' + Constants_1.TIME_LABEL + '</div>'
            + '<div class="value">' + this.startTime + '-' + this.endTime + '</div>'
            + '</div>'
            + '<div class="row">'
            + '<div class="label">' + Constants_1.NUMBER_LABEL + '</div>'
            + '<div class="value">' + projectDetails.number + '</div>'
            + '</div>'
            + '<div class="row">'
            + '<div class="label">' + Constants_1.TYPE_LABEL + '</div>'
            + '<div class="value">' + projectDetails.type + '</div>'
            + '</div>'
            + '<div class="row">'
            + '<div class="label">' + Constants_1.STREET_LABEL + '</div>'
            + '<div class="value">' + projectDetails.street + '</div>'
            + '</div>'
            + '<div class="row">'
            + '<div class="label">' + Constants_1.CITY_LABEL + '</div>'
            + '<div class="value">' + projectDetails.city + '</div>'
            + '</div>'
            + '</div>');
    };
    return WorkMarker;
}(Marker));
exports.WorkMarker = WorkMarker;
var ClusterMarker = /** @class */ (function () {
    function ClusterMarker(_a) {
        var args = __rest(_a, []);
        this.numPoints = args.numPoints;
        this.wx = args.wx;
        this.wy = args.wy;
        this.x = args.x;
        this.y = args.y;
        this.zoom = args.zoom;
        this.points = args.points;
    }
    ClusterMarker.prototype.getOptions = function () {
        return {
            position: { lat: this.wy, lng: this.wx },
            zIndex: 10,
            label: {
                text: this.numPoints.toString(),
                color: 'white',
                fontSize: '10px',
            },
        };
    };
    ClusterMarker.prototype.getInfoWindowContent = function () {
        var displayedPoints = _.slice(this.points, 0, Constants_1.INFO_WINDOW_DISPLAY_MAX_POINTS);
        var rows = _.map(displayedPoints, function (point) {
            var time = utils_1.ACTIVITY_MAPPER[point.type].isTimeRange
                ? " ".concat(point.startTime, "-").concat(point.endTime, " ") : " ".concat(point.startTime, " ");
            return '<div id="marker-info">'
                + '<div class="row">'
                + '<div class="label">' + utils_1.ACTIVITY_MAPPER[point.type].label + '</div>'
                + '<div class="value">' + time + '</div>'
                + '</div>'
                + '</div>';
        });
        var leftPointsNumber = this.points.length - rows.length;
        var tailSentence = this.points.length > Constants_1.INFO_WINDOW_DISPLAY_MAX_POINTS ?
            "and ".concat(leftPointsNumber, " more points ...") : '';
        return rows.join(' ') + tailSentence;
    };
    return ClusterMarker;
}());
exports.ClusterMarker = ClusterMarker;
